import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import DragDropContext from '../../../../mocks/react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import {wrapNotFound} from '../../app/NotFoundHandler.react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {FullScreenPanel} from '../EmbededPanel.react';
import {getEditViewFragment} from './../box-utils/ScreenDisplayer.react';
import JsonTableConfig, {tableInstacne} from '../box/system/JSONTableConfigTable.react';
import {EntityViewDefView} from '../../entity-view-defs/EntityViewDefView.react';
import {getMessageArgsForDataSource} from './DataSourceList.react';
import OPENERS from './WidgetConfigOpeners';
import {isOutlookPanel, isScreenSettingsOnlyIframe, screenSettingsOnlyClose} from '../../../outlook/dialog';
import {lastPanelController} from '../EmbededPanelController';
import urlMapping from '../../app/URLMapping';
import types from '../../../common/model-api/types';
import EditorSaver from '../../fw/EditorSaver';
import deepEqual from 'deep-equal';
import {getLastOrganisationId} from '../../app/LastOrganisationId';

import './../Panels.scss';
import './../View.scss';
import './ScreenSettings.scss';
import '../box/system/JSONTable.scss';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

class WidgetConfig extends React.Component {
	static propTypes = {
		intl: PropTypes.object.isRequired,
        params: PropTypes.object,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};

    static contextTypes = {
        router: PropTypes.object,
    };

	constructor(props) {
		super(props);

		this.state = {
			isSaving: false
		};

		// TODO create save object to determine if the next change should trigger save
		// this.lastSavedObject = {
		// 	id: props.user.organisation.channel.screen.realId,
		// 	view: {
		// 		id: props.user.organisation.channel.screen.view.realId,
		// 		template: props.user.organisation.channel.screen.view.template,
		// 		filter: props.user.organisation.channel.screen.view.filter,
		// 		order: props.user.organisation.channel.screen.view.order
		// 	}
		// };
	}

	getDataSources() {
		let dataSources = [safeJSONparse(JSON.stringify(this.props.user.organisation.channel.screen.view.dataSource))];

		return dataSources.map((dataSource, idx) => {
			let parentDataSource = dataSource.relativeTo ? dataSources.find(item => item.realId === dataSource.relativeTo.realId) : null;
			let messageArgs = getMessageArgsForDataSource(dataSource, parentDataSource);
			let title = this.props.intl.formatMessage({
				id: 'dataSource.' + dataSource.typeId + '.name',
			}, messageArgs);

			dataSource.title = title;

			dataSource.fields = dataSource.mappedFields
				.filter((item, idx) => { return idx === dataSource.mappedFields.findIndex(field => field.realId === item.realId);})
				.map(item => {
					item.dataSourceId = dataSource.realId;
					item.dataSourceIdx = idx;

					return {
						fieldDef: item,
						dataSourceId: dataSource.realId,
						dataSourceIdx: idx,
					};
				});

			return dataSource;
		});
	}

	getViewWithData() {
		let view = this.props.user.organisation.channel.screen.view;
		let viewWithData = EntityViewDefView.constructViewWithData(view.entityViewDef, view.entityViewDef.entityDef);

		if (view.template) {
			viewWithData.view.entityViewDef.template = view.template;
		}

		if (safeJSONparse(view.order || '[]').length > 0) {
			viewWithData.view.entityViewDef.order = view.order;
		}

		if (safeJSONparse(view.filter || '{}').limit) {
			viewWithData.view.entityViewDef.filter = view.filter;
		}

		let dataSources = this.getDataSources();
		let allFieldDefs = dataSources.reduce((a, b) => a.concat(b.fields), []);

		allFieldDefs = allFieldDefs.map((field) => {
			return {
				node: field.fieldDef,
			};
		});

		viewWithData.entityDef.allFieldDefs = {
			edges: allFieldDefs,
		};

		return viewWithData;
	}

	closeEditing() {
		if (OPENERS.PANEL === this.props.params.opener) {
			if (isOutlookPanel()) {
				window.close();
			}
			else if (isScreenSettingsOnlyIframe()) {
				screenSettingsOnlyClose();
			}
			else {
				lastPanelController().cancelMinimizePanel();

				let path = urlMapping.getUrl("panel", "panel", lastPanelController().getURLObject());
				this.context.router.push(path);
			}
		}
		else {
			let pathObject = {
				organisation_id: this.context.router.params.organisationId,
				channel_id: this.context.router.params.channelId,
				screen_id: this.context.router.params.screenId,
			};
			let path = urlMapping.getUrl('panel', 'screen-settings', pathObject);
			this.context.router.push(path);
		}
	}

	saveData() {
		let data = tableInstacne.getSaveData({});

		let entityViewDef = this.props.user.organisation.channel.screen.view.entityViewDef;

		let saveObject = {
			id: this.props.user.organisation.channel.screen.view.id,
			template: data.template !== entityViewDef.template ? data.template : null,
			filter: JSON.stringify(JSON.stringify(data.filter) !== entityViewDef.filter ? data.filter : {}),
			order: JSON.stringify(JSON.stringify(data.order) !== entityViewDef.order ? data.order : []),
		};

		if (deepEqual(saveObject, this.lastSavedObject)) {
			return; // no cahnges to save
		}

		this.lastSavedObject = saveObject;

        let fatQuery = Relay.QL `
                fragment on UpdateViewPayload {
                    updatedNode {
						id,
						template,
						filter,
						order
					},
                }
            `;

        let mutation = Relay.QL `mutation { updateView }`;

		// eslint-disable-next-line max-params
		let saver = new EditorSaver(types['views'], mutation, fatQuery, null, null, (data, storeData, defaultValue, columns) => {
			return saveObject;
		});
		return saver.save({}).then(() => {
			if (lastPanelController()) {
                lastPanelController().ensureWeReloadData();
            }
		});
	}

	render() {
		return (
			<FullScreenPanel className="screenSettings widgetConfig" showBackToPanel typeForTest="WidgetConfig">
				<div className="nav screenSettings-toolbar">
					<div className="nav btn-toolbar" role="toolbar">
						<button className="btn btn-success" onClick={this.closeEditing.bind(this)}><span className="fa fa-check"/> <FormattedMessage defaultMessage="Done" id="screenSettings.close" /></button>
					</div>

					<div className="nav screenSettings-title">
						<FormattedMessage defaultMessage="Table configuration" id="widgetConfig.tableConfigTitle" />
					</div>

					{this.state.isSaving ? <div className="btn-group saving">
						<div><span className="fa fa-spin fa-refresh fa-fw"/> <FormattedMessage defaultMessage="Saving" id="screenSettings.saving" /></div>
					</div> : null }
				</div>
				<JsonTableConfig
					dataSources={this.getDataSources()}
					isDetailView={this.props.user.organisation.channel.screen.view.handler	 === 'json-detail'}
					onChange={this.saveData.bind(this)}
					viewWithData={this.getViewWithData()}
					widgetConfigView
				/>
			</FullScreenPanel>
		);
	}
}

export default Relay.createContainer(DragDropContext(HTML5Backend)(wrapNotFound(injectIntl(WidgetConfig), (props) => {
    // return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.screen;
	return true;
})), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        screenId: '',
		viewId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
					iotTopic,
                    organisation(id: $organisationId) {
                        id,
                        channel(id: $channelId) {
                            id,
                            realId,
                            screen(id: $screenId) {
                                id,
                                realId,
                                view(id: $viewId) {
                                    ${getEditViewFragment()},
									dataSource {
										id,
										realId,
										name,
										description,
										typeId,
										relativeTo {
											id,
											realId
										},
										entityDefs {
											name
										},
										channelDefs {
											name
										},
										mappedFields {
			                                id,
			                                realId,
			                                name,
					                        name_l {
					                            locale,
					                            content
					                        },
											shortName,
					                        shortName_l {
					                            locale,
					                            content
					                        },
			                                key,
			                                type,
											exampleData,
										}
									}
                                }
                            }
                        }
                    }
                }`;
        }
    }
});
